export function UnderstandingYourOptions() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Understanding Your Selling Options
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            When it comes to selling your apartment building, you face a critical decision that can impact your timeline, stress levels, and final profit. Let's explore both paths in detail.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* AS IS Option */}
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border-2 border-teal-200">
            <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-hand-coin-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">Selling AS IS</h3>
            <p className="text-lg text-gray-700 mb-6">
              Selling your apartment building in its current condition means the buyer accepts the property with all existing issues, deferred maintenance, and cosmetic concerns. You make no repairs or improvements before closing.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-teal-600 mt-1"></i>
                <span className="text-gray-700">No upfront renovation costs</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-teal-600 mt-1"></i>
                <span className="text-gray-700">Fast closing timeline (7-30 days)</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-teal-600 mt-1"></i>
                <span className="text-gray-700">Zero stress from managing contractors</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-teal-600 mt-1"></i>
                <span className="text-gray-700">Immediate liquidity and cash flow</span>
              </div>
            </div>
          </div>

          {/* Remodel Option */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-2 border-gray-200">
            <div className="w-16 h-16 bg-gray-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-hammer-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">Remodeling First</h3>
            <p className="text-lg text-gray-700 mb-6">
              Investing in renovations, upgrades, and repairs before listing your property. This can range from cosmetic improvements to major structural work, with the goal of commanding a higher sale price.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-tools-line text-xl text-gray-600 mt-1"></i>
                <span className="text-gray-700">Significant upfront capital required</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-xl text-gray-600 mt-1"></i>
                <span className="text-gray-700">Extended timeline (6-18 months)</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-xl text-gray-600 mt-1"></i>
                <span className="text-gray-700">Contractor management stress</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-question-line text-xl text-gray-600 mt-1"></i>
                <span className="text-gray-700">Uncertain return on investment</span>
              </div>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://public.readdy.ai/ai/img_res/fca5226807f19c94093ac46baa2ec0d4.jpg"
            alt="Analyzing apartment building selling options"
            className="w-full h-[500px] object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}